import { Button, Divider, Input, Modal, Typography } from "antd";
import classes from "./AppDashboard.module.scss";
import { SwapOutlined } from "@ant-design/icons";
import logoDark from "../../assets/images/sord_logo_transparent.png";
import { useEffect, useState } from "react";

const CreateTaskModal = ({
  isOpen,
  onClose,
  selectedWorkspace,
  selectedProject,
  createTask,
}) => {
  const [taskName, setTaskName] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleCreateTask = () => {
    if (!taskName) return;
    setIsLoading(true);
    createTask(taskName);
  };

  useEffect(() => {
    return () => {
      setTaskName("");
      setIsLoading(false);
    };
  }, []);

  return (
    <Modal centered open={isOpen} onCancel={onClose} footer={null}>
      <div className={classes.modalContainer}>
        <div className={classes.integratedAppsCnt}>
          <img src={logoDark} height={50} className={classes.logoDark} />
          <SwapOutlined style={{ fontSize: "25px", color: "#989898" }} />
          <img src={selectedWorkspace?.image || ""} height={50} />
        </div>
        <span className={classes.title}>
          Create Task in {selectedProject?.name}
        </span>
        <span className={classes.subTitle} style={{ textAlign: "center" }}>
          {selectedWorkspace.description}
        </span>
        <div className={classes.inputContainer}>
          <span>Task Name</span>
          <Input
            placeholder="Enter Task Name"
            value={taskName}
            onChange={(e) => setTaskName(e.target.value)}
          />
        </div>
        <Button
          type="primary"
          block
          loading={isLoading}
          onClick={handleCreateTask}
        >
          Create Task
        </Button>
        <Divider />
        <span className={classes.subTitle}>
          By clicking on Create Task, you are authorizing Radar+ to create a
          task in your <Typography.Link>Asana Account.</Typography.Link> You can
          disconnect your app any time on the integrations page of your account.
        </span>
      </div>
    </Modal>
  );
};
export default CreateTaskModal;
